import { Wrench, FileText, ShoppingCart, Lightbulb, CheckCircle2 } from "lucide-react";
import { services } from "../mock";
import PageHero from "../components/PageHero";
import CTASection from "../components/CTASection";

const iconMap = { Wrench, FileText, ShoppingCart, Lightbulb };

const process = [
  ["Survey & Consultation", "We assess your windows, access and ventilation requirements on site or from drawings."],
  ["Specification & Quote", "We recommend the right products and provide a clear, competitive quotation."],
  ["Installation", "Our engineers install manual or electric systems cleanly and safely, nationwide."],
  ["Commissioning & Aftercare", "We test, commission and support your system to ensure reliable long-term performance."],
];

const Services = () => {
  return (
    <div>
      <PageHero
        eyebrow="What We Offer"
        title="Services"
        subtitle="From full nationwide installation to direct supply and expert advice, we provide a complete window control and natural ventilation service."
      />

      <section className="bg-white py-16 md:py-20">
        <div className="mx-auto max-w-7xl space-y-6 px-5 md:px-8">
          {services.map((s, i) => {
            const Icon = iconMap[s.icon];
            return (
              <div
                key={s.id}
                id={s.id}
                className="grid items-center gap-8 rounded-2xl border border-gray-100 bg-gray-50 p-8 md:grid-cols-[auto,1fr] md:p-10"
              >
                <div className="flex h-20 w-20 items-center justify-center rounded-2xl bg-[#0f2a5a] text-white">
                  <Icon size={34} />
                </div>
                <div>
                  <span className="text-xs font-semibold uppercase tracking-widest text-[#1d4ed8]">
                    0{i + 1}
                  </span>
                  <h2 className="mt-1 font-head text-2xl font-700 text-[#0f2a5a]">{s.title}</h2>
                  <p className="mt-3 text-base leading-relaxed text-gray-600">{s.body}</p>
                </div>
              </div>
            );
          })}
        </div>
      </section>

      {/* Process */}
      <section className="bg-gray-50 py-16 md:py-20">
        <div className="mx-auto max-w-7xl px-5 md:px-8">
          <div className="mb-12 text-center">
            <p className="eyebrow text-[#1d4ed8]">How We Work</p>
            <h2 className="heading-xl mt-3 text-3xl text-[#0f2a5a] md:text-4xl">Our Process</h2>
            <div className="ld-accent-bar mx-auto mt-5" />
          </div>
          <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-4">
            {process.map(([title, text], i) => (
              <div key={title} className="relative rounded-xl border border-gray-100 bg-white p-7">
                <span className="font-head text-4xl font-800 text-blue-100">{`0${i + 1}`}</span>
                <h3 className="mt-2 font-head text-lg font-700 text-[#0f2a5a]">{title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-gray-600">{text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why us */}
      <section className="bg-white py-16 md:py-20">
        <div className="mx-auto max-w-5xl px-5 md:px-8">
          <div className="mb-10 text-center">
            <p className="eyebrow text-[#1d4ed8]">Why Choose L&D</p>
            <h2 className="heading-xl mt-3 text-3xl text-[#0f2a5a] md:text-4xl">The L&amp;D Difference</h2>
            <div className="ld-accent-bar mx-auto mt-5" />
          </div>
          <div className="grid gap-4 sm:grid-cols-2">
            {[
              "First-hand product knowledge of manual & electric systems",
              "Full nationwide installation service",
              "Competitive, transparent quotations",
              "Residential, commercial, education & healthcare",
              "Direct supply of parts & components",
              "Genuine, independent expert advice",
            ].map((f) => (
              <div key={f} className="flex items-start gap-3 rounded-lg border border-gray-100 bg-gray-50 p-4">
                <CheckCircle2 size={20} className="mt-0.5 shrink-0 text-[#1d4ed8]" />
                <span className="text-sm text-gray-700">{f}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      <CTASection />
    </div>
  );
};

export default Services;
